import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import { CustomerResponse } from '../../customer/models/customer-service.model';
import { Customer, CustomerLocation } from '../../shared/models/shared.model';
import {
  ContactpersonResponse,
  CustomerRelationLocationResponse,
} from '../models/contactperson-service.model';
import { Contactperson } from '../models/contactperson.model';

@Injectable()
export class ContactpersonService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = `${this.env.API_BASE_URL}/service/customer-account-management/secure/`;

  getContactpersons(searchtext: string): Observable<Contactperson[]> {
    return this.http
      .get<ContactpersonResponse>(`${this.baseUrl}contactpersons?query=${searchtext}`)
      .pipe(
        map((response: ContactpersonResponse) => response.contactPersons),
        catchError((error: HttpErrorResponse) => throwError(error.status)),
      );
  }

  getContactpersonById(id: number): Observable<Contactperson> {
    return this.http.get<Contactperson>(`${this.baseUrl}contactpersons/${id}`);
  }

  upsertContactperson(contactperson: Contactperson): Observable<Contactperson> {
    return this.http.post<Contactperson>(`${this.baseUrl}contactpersons`, contactperson, {});
  }

  getCustomerRelationsForContactperson(contactpersonId: number): Observable<Customer[]> {
    return this.http
      .get<CustomerResponse>(`${this.baseUrl}contactpersons/${contactpersonId}/customers`)
      .pipe(
        map((response: CustomerResponse) => response.customers),
        catchError((error: HttpErrorResponse) => throwError(error.status)),
      );
  }

  getLocationsForRelationWithCustomer(
    customerId: number,
    contactpersonId: number,
  ): Observable<CustomerLocation[]> {
    return this.http
      .get<CustomerRelationLocationResponse>(
        `${this.baseUrl}customers/${customerId}/locations/contactpersons/${contactpersonId}`,
      )
      .pipe(
        map((response: CustomerRelationLocationResponse) => <CustomerLocation[]>response.locations),
        catchError((error: HttpErrorResponse) => throwError(error.status)),
      );
  }

  setRelationWithLocationRequest(
    customerId: number,
    contactpersonId: number,
    locationIds: Array<number>,
  ): Observable<unknown> {
    return this.http
      .post(
        `${this.baseUrl}customers/${customerId}/locations/contactpersons/${contactpersonId}`,
        { relatedLocationIds: locationIds },
        {},
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(error.status)));
  }
}
